const STATUS_CAR_RENTING = 'suscripcion'
const STATUS_CAR_NEW = 'Nuevo'
const STATUS_CAR_VO = 'Automóvil Turismo'
const STATUS_ALL_TERRAIN_VO = 'Automóvil Todo Terreno'

const RENTING_BING_EVENT_NAME = 'lead_renting'
const NEW_BING_EVENT_NAME = 'lead_vn'
const VO_BING_EVENT_NAME = 'lead_VO'
const PTA_BING_EVENT_NAME = 'lead_PTA'
const C2B_BING_EVENT_NAME = 'lead_C2B'

const propertiesMapping = {
  [STATUS_CAR_RENTING]: RENTING_BING_EVENT_NAME,
  [STATUS_CAR_NEW]: NEW_BING_EVENT_NAME,
  [STATUS_CAR_VO]: VO_BING_EVENT_NAME,
  [STATUS_ALL_TERRAIN_VO]: VO_BING_EVENT_NAME
}

export const getProperties = ({event, properties = {}}) => {
  if (event === 'Lead Triggered') {
    const {status_car: statusCar} = properties

    const eventName = propertiesMapping[statusCar]

    return eventName
  }

  if (event === 'Ad Inserted') {
    return PTA_BING_EVENT_NAME
  }

  if (event === 'Ad Insertion IO Date Confirmed' || event === 'Landing IO Date Confirmed') {
    return C2B_BING_EVENT_NAME
  }
}
